// import { put } from 'redux-saga/effects';
// import { getCommonRequest } from 'modules/common/store/dfdunk'
export function* basicConfigSaga() {

}
